(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveals al hacer scroll (un solo observer compartido)
  var observer = null;
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mt-reveal:not(.mt-visible), .mt-hero:not(.mt-visible), .mt-comp:not(.mt-visible)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mt-visible'); observer.unobserve(e.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  // Manifiesto: palabras que se iluminan según el scroll
  function initManifiestos() {
    document.querySelectorAll('[data-mt-manifiesto]').forEach(function (el) {
      if (el.dataset.mtInit) return;
      el.dataset.mtInit = '1';
      var palabras = el.querySelectorAll('.mt-palabra');
      if (reduce) { palabras.forEach(function (p) { p.classList.add('mt-on'); }); return; }
      function pinta() {
        var r = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var progreso = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        progreso = Math.max(0, Math.min(1, progreso));
        var n = Math.round(progreso * palabras.length);
        palabras.forEach(function (p, i) { p.classList.toggle('mt-on', i < n); });
      }
      window.addEventListener('scroll', pinta, { passive: true });
      window.addEventListener('resize', pinta);
      pinta();
    });
  }

  // FAQ desplegable
  function initFaqs() {
    document.querySelectorAll('.mt-faq__btn').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mt-faq__item');
        var abierto = item.classList.toggle('mt-abierto');
        btn.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  // Botón magnético (solo con ratón)
  function initMagneticos() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('.mt-magnetico').forEach(function (btn) {
      if (btn.dataset.mtInit) return;
      btn.dataset.mtInit = '1';
      var zona = btn.parentElement;
      zona.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var dx = e.clientX - (r.left + r.width / 2);
        var dy = e.clientY - (r.top + r.height / 2);
        if (Math.abs(dx) > r.width || Math.abs(dy) > r.height * 2) { btn.style.transform = ''; return; }
        btn.style.transform = 'translate(' + (dx * 0.08).toFixed(1) + 'px,' + (dy * 0.12).toFixed(1) + 'px)';
      });
      zona.addEventListener('mouseleave', function () { btn.style.transform = ''; });
    });
  }

  // Página de producto: galería y variantes
  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (raiz) {
      if (raiz.dataset.mtInit) return;
      raiz.dataset.mtInit = '1';
      var principal = raiz.querySelector('[data-mt-principal]');
      var minis = raiz.querySelectorAll('[data-mt-mini]');
      function muestra(src, alt, boton) {
        if (!principal) return;
        principal.src = src;
        principal.alt = alt || '';
        minis.forEach(function (m) { m.classList.toggle('mt-activa', m === boton); });
      }
      minis.forEach(function (m) {
        m.addEventListener('click', function () { muestra(m.dataset.src, m.dataset.alt, m); });
      });

      var datos = raiz.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var form = raiz.querySelector('form[action*="/cart/add"]');
      var inputId = form ? form.querySelector('input[name="id"]') : null;
      var boton = raiz.querySelector('[data-mt-boton]');
      var precio = raiz.querySelector('[data-mt-precio]');
      var tachado = raiz.querySelector('[data-mt-tachado]');
      var formato = raiz.dataset.mtMoneda || '{{amount}}';
      function dinero(cents) {
        var v = (cents / 100).toFixed(2);
        return formato.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
          .replace(/\{\{\s*amount\s*\}\}/, v)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }
      raiz.querySelectorAll('[data-mt-opcion] input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var elegidas = [];
          raiz.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === elegidas[i]; });
          });
          if (!v) return;
          if (inputId) inputId.value = v.id;
          if (precio) precio.textContent = dinero(v.price);
          if (tachado) {
            var hay = v.compare_at_price && v.compare_at_price > v.price;
            tachado.textContent = hay ? dinero(v.compare_at_price) : '';
            tachado.hidden = !hay;
          }
          if (boton) {
            boton.disabled = !v.available;
            boton.textContent = v.available ? boton.dataset.textoOk : boton.dataset.textoAgotado;
          }
          if (v.featured_image && principal) {
            var m = Array.prototype.find.call(minis, function (x) { return x.dataset.mediaId == v.featured_media_id; });
            muestra(v.featured_image.src, v.featured_image.alt, m || null);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function initTodo(e) {
    initReveals(e && e.target);
    initManifiestos();
    initFaqs();
    initMagneticos();
    initProducto();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
